import Home from "@/components/Dashboard/Home.vue";

export default [
    {
        path: 'home',
        name: 'Home',
        components: {
            page: Home,
        },
        meta: {
            requiresAuth: true
        },
        children: [
            /*
            {
                path: "filter",
                name: "Filter",
                components: {
                    modal: Filter
                }
            },
            {
                path: "list/:filter?",
                name: "List",
                components: {
                    // ... NONE
                }
            },
            {
                path: "edit/:id",
                name: "Edit",
                components: {
                    modal: Edit,
                }
            }
            */
        ]
    }
];